export const TOGGLE_MODAL = '@@archive/TOGGLE_MODAL';

export const toggleModal = (dataType = '', title = '') => ({
  type: TOGGLE_MODAL,
  data: {
    dataType,
    title
  }
});
